import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.34_cac@6._66079225ea7e417ec6cbbb3824db86a0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.6_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.34_cac@6._66079225ea7e417ec6cbbb3824db86a0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}